<template>
  <div class="login">
      <p class="span">欢迎登录</p>
      <p>健康管理云平台</p>
      <div class="mobile">
        <img src="../assets/mobile.png" alt="">
        <span></span>
        <input type="text" placeholder="请输入手机号" v-model="input1">
      </div>
      <div class="password">
        <img src="../assets/password.png" alt="">
        <span></span>
        <input type="password" placeholder="请输入验证码" v-model="input2">
        <button @click="loginIn()" v-show="show">获取验证码</button>
        <button v-show="!show">{{counts}}</button>
      </div>
      <div class="btn">
        <button @click="resetpassword()">快速登录</button>
      </div>
      <!-- <div class="logo">
        <img src="../assets/logo.png" alt="">
      </div> -->
  </div>
</template> 

<script>
import axios from "axios";
export default {
  data() {
    return {
      input1: "",
      input2: "",
      counts: "",
      show: true,
    };
  },
  created() {},
  methods: {
    loginIn() {
      var _this = this;
      var re = /^1\d{10}$/;
      if (!re.test(this.input1)) {
        this.$toast.text("请填写正确手机号码");
      } else {
        axios
          .post(BASE_URL + "/auth/mobile/token/", {
            mobile: _this.input1
          })
          .then(res => {
            console.log(res);
            let TIME_COUNT = 60;
            if (!_this.timer) {
              _this.counts = TIME_COUNT;
              _this.show = false;
              _this.timer = setInterval(() => {
                if (_this.counts > 0 && _this.counts <= TIME_COUNT) {
                  _this.counts--;
                } else {
                  _this.show = true;
                  clearInterval(_this.timer);
                  _this.timer = null;
                }
              }, 1000);
            }
          });
      }
    },
    resetpassword() {
      var _this = this;
      var re = /^1\d{10}$/;
      if (!re.test(this.input1)) {
        this.$toast.text("请填写正确手机号码");
      } else if (!this.input2) {
        this.$toast.text("请填写验证码");
      } else {
        axios
          .post(BASE_URL + "/auth/mobile/login/", {
            mobile: _this.input1,
            token: _this.input2
          })
          .then(res => {
            let result = res.data;
            console.log(res);
            sessionStorage.setItem("TOKEN", result.token);
            sessionStorage.setItem("username", result.user.profile.realname);
           sessionStorage.setItem("setUser", result.user.profile.realname);
            _this.$router.push({
              path: "/index"
            });
          });
      }
    }
  }
};
</script>

<style scoped>
.login {
  max-width: 750px;
  background: #fff;
}
.login .span {
  font-size: 16px;
  text-align: center;
  margin-top: 40px;
}
.login p {
  font-size: 24px;
  text-align: center;
  margin-top: 10px;
}
.mobile,
.password {
  display: flex;
  height: 48px;
  line-height: 48px;
  margin: 0 20px;
  border-bottom: 1px solid #eaeaea;
}
.mobile {
  margin-top: 50px;
}
span {
  margin: 14px 5px;
  border-left: 2px solid #333;
}
.mobile img,
.password img {
  width: 15px;
  height: 20px;
  margin: 15px 5px;
}
input {
  font-size: 16px;
  width: 65%;
}
.password button {
  width: 100px;
  font-size: 14px;
  border: 1px solid #e24709;
  border-radius: 2px;
  margin: 10px 0;
  padding: 0 5px;
  color: #e24709;
}
.btn {
  margin: 0 20px;
}
.btn button {
  height: 48px;
  line-height: 48px;
  font-size: 18px;
  margin-top: 86px;
  text-align: center;
  background: #e24709;
  color: #fff;
  width: 100%;
}
.logo {
  position: fixed;
  left: 0;
  bottom: 35px;
  width: 100%;
  margin: 0 auto;
}
.logo img {
  width: 119px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue